import { RootState } from 'types';
import { ISceneConfigDAO } from 'types/domain/scene';
import { createSelector } from '@reduxjs/toolkit';
import { selectSceneConfig } from './scene/sceneConfig';

//@ts-ignore
const sceneConfig = (state: RootState, id?) => selectSceneConfig(state, null, id);

export const selectShouldAnimate = createSelector([sceneConfig], (sceneConfig: ISceneConfigDAO) => {
  return sceneConfig ? sceneConfig.shouldAnimate : false;
});
